import { Input, InputWrapperProps } from "@mantine/core";
import { FORM_HELPER_CONSTS, useFormHelperContext } from "./form";

export const InputWrapper: React.FC<InputWrapperProps> = ({ label, classNames, children, ...rest }) => {
    const { formStore } = useFormHelperContext()
    return (
        <Input.Wrapper
            label={label}
            classNames={formStore.horizontalForm ? FORM_HELPER_CONSTS.HORIZONTAL_FORM_CLASSES_WRAPPER : undefined}
            {...rest}
        >
            {children}
        </Input.Wrapper>
    );
}